import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import SEO from '../components/common/SEO';
import PageContentBlocks from '../components/common/PageContentBlocks';
import usePageContent from '../hooks/usePageContent';

export default function AboutPage() {
  const { t, i18n } = useTranslation();
  const { blocks } = usePageContent('about', i18n.language);

  return (
    <>
      <SEO title={t('about.title')} description={t('about.missionText')} />
      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="section-title text-center mb-12">
            {t('about.title')}
          </motion.h1>
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="card">
              <span className="text-4xl">🎯</span>
              <h2 className="text-xl font-bold mt-4 mb-3">{t('about.mission')}</h2>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">{t('about.missionText')}</p>
            </motion.div>
            <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="card">
              <span className="text-4xl">🌟</span>
              <h2 className="text-xl font-bold mt-4 mb-3">{t('about.vision')}</h2>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">{t('about.visionText')}</p>
            </motion.div>
          </div>

          <PageContentBlocks blocks={blocks} />

          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            className="card mt-8 text-center bg-card-gradient">
            <p className="text-2xl font-display font-bold gradient-text">{t('tagline')}</p>
            <p className="mt-4 text-gray-500">Built with ❤️ by Kallcy Global India Pvt. Ltd</p>
          </motion.div>
        </div>
      </section>
    </>
  );
}
